import qrcode from "qrcode-generator";
import { useMemo } from "react";

/** QR code as SVG rects (no innerHTML). Always dark-on-white for scanners. */
export function QR({ value, size = 200 }: { value: string; size?: number }) {
  const cells = useMemo(() => {
    const qr = qrcode(0, "M");
    qr.addData(value);
    qr.make();
    const n = qr.getModuleCount();
    const out: string[] = [];
    for (let r = 0; r < n; r++) for (let c = 0; c < n; c++) if (qr.isDark(r, c)) out.push(`M${c} ${r}h1v1h-1z`);
    return { n, d: out.join("") };
  }, [value]);
  return (
    <div className="qr">
      <svg width={size} height={size} viewBox={`0 0 ${cells.n} ${cells.n}`} role="img" aria-label={`QR code for ${value}`} shapeRendering="crispEdges">
        <path d={cells.d} fill="#16181D" />
      </svg>
    </div>
  );
}
